module.exports = __webpack_public_path__ + "img/Vitasoy.601ce264.png";